<template>
    <div class="page4-container">
        <div class="content-header">
            <p class="title">Step 2: Pick a Gift Box Design</p>
            <p class="subtitle">don't worry, these will fit your items perfectly!</p>
        </div>
        <ul v-if="bestBoxes.length > 0" class="boxes-container">
            <li v-for="box in bestBoxes" :key="box.id">
                <div class="box-container">
                    <div class="main-image-container" :class="(selectedBoxProduct && selectedBoxProduct.id == box.id) ? 'selected' : '' ">
                        <img v-if="selectedBoxProduct && selectedBoxProduct.id == box.id" class="green-check" src="https://cdn.shopify.com/s/files/1/1363/8433/files/check-circle.svg?v=1658433688"/>
                        <img @click="selectBox(box)" class="main-image lazyload" width="280" height="280" :data-src="box | getProductImage">
                    </div>
                    <p class="box-title">{{box.title}}</p>
                    <p class="box-desc">{{box | moneyFormat}}</p>
                    <button v-if="selectedBoxProduct && selectedBoxProduct.id == box.id" @click="changePage(true)" class="happybox-button green border">Next</button>
                    <button v-else @click="selectBox(box)" class="happybox-button white border">Select Design</button>
                </div>
            </li>
        </ul>
        <div v-if="extendedProducts && isExtendedBoxes" class="box-warning">
            <img src="https://cdn.shopify.com/s/files/1/1363/8433/files/error_icon_2a88e148-df0e-480c-85b8-89b7d9d6e5ba.svg?v=1741881886" class="alert-icon"/>
            <p>Want to see more box options? <br/> Remove <strong>{{ extendedProducts }}</strong> to see more designs and sizes!</p>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
    data(){
        return {
            isSticking: true,
        }
    },
    computed: {
        ...mapGetters([
            'boxProducts',
            'selectedBoxProduct',
            'currentCapacity',
            'selectedAddonProducts',
            "boxQty",
            'maxCapacity',
        ]),
        bestBoxes(){
            //Get if it has a fragile product. If so, only show big boxes
            var fragile = this.selectedAddonProducts.some(x => x.tags.includes("XLTRIGGER"));

            let separatedBoxes = this.boxProducts.filter((x) => {
                let tags = x.tags.split(",");
                if(tags.some(y => y.includes("QTYMIN"))){
                    let minTag = tags.find(x => x.includes("QTYMIN"));
                    if(minTag){
                        minTag = minTag.split("_");
                        minTag = minTag[minTag.length - 1];

                        return this.boxQty >= minTag;
                    }

                    return false
                }

                return true
            })

            
            //Get all boxes variants
            separatedBoxes = separatedBoxes.flatMap((box) => {
                var boxes = box.variants.map((variant) =>{
                    var currentBoxes = JSON.parse(JSON.stringify(box));;
                    currentBoxes.variants = [variant];

                    return currentBoxes;
                })

                return boxes;
            })

            separatedBoxes = separatedBoxes.filter(x => x.variants[0].inventory_quantity >= this.boxQty);
            let sizes = separatedBoxes.map(x => x.variants[0].title);
            let uSizes = [...new Set(sizes)];
            let boxSize = null;
            uSizes.sort();
            if(fragile){
                let minBox = Math.min(...uSizes);
                boxSize = Math.min(...uSizes.filter(x => x >= this.currentCapacity && x != minBox)); 
            }
            else {
                boxSize = Math.min(...uSizes.filter(x => x >= this.currentCapacity)); 
            }
            separatedBoxes = separatedBoxes.filter(x => x.variants[0].title == boxSize);

            return separatedBoxes;
        },
        currentMaxCapacity(){
            return this.maxCapacity;
        },
        lesserMaxCapacity(){
            //get biggest box that is not extended
            let capacities = this.boxProducts.filter(x => !x.title.toLowerCase().includes("extended")).map(x => x.variants).flat().filter(x => x.available).map(x => parseInt(x.option1)).sort((a,b) => b - a);
            return capacities.find(x => x < this.currentMaxCapacity)
        },
        isExtendedBoxes(){
            return this.currentCapacity > this.lesserMaxCapacity;
        },
        extendedProducts(){
            if(this.isExtendedBoxes){
                //find a product that when removed jumps to not extended box
                let cartProducts = JSON.parse(JSON.stringify(this.selectedAddonProducts))
                let products = cartProducts.sort((a,b) => b.capacity - a.capacity);//.find(x => (this.currentCapacity - x.capacity) <= this.lesserMaxCapacity);
                let titles = [];
                let capacity = Number(this.currentCapacity);
                for(let i = 0; capacity > this.lesserMaxCapacity; i++){
                    titles.push(products[i].title);
                    capacity = capacity - (products[i].capacity * products[i].quantity);
                }

                return titles.join(", ");
            }

            return null
        },
    },
    methods: {
        selectBox(box){
            this.$store.commit('updateSelectedMainProduct', box);
            if(this.isMobile()){
                var myDiv = document.getElementById('scroll-container');
                myDiv.style.scrollBehavior = "unset";
                myDiv.scrollTop = 0;
                myDiv.style.scrollBehavior = "smooth";
                this.$emit("changepage", true);
            }
        },
        isMobile() {
            return window.innerWidth < 768;
        },
        changePage(){
            this.$emit("changepage", true);
        }
    },
    mounted(){
    },
    beforeDestroy() {
    }

}
</script>

<style scoped>

.page4-container{
    height: calc(100% - 60px);
    display: flex;
    flex-direction: column;
    align-items: center;
}
.main-title{
    color: #0F0C38;
    font-family: 'moret',sans-serif !important;
    font-size: 2.5vw;
    margin-top: 2%;
    letter-spacing: 0.03em;
}

.main-subtitle img{
    width: 1.5%;
    margin: 0% 0.2%;
}

.main-subtitle{
    font-size: 1.2vw;
    color: #3f3d60;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
}

.boxes-container{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    list-style: none;
    justify-content: center;
    margin: unset;
    padding: 3% 10% 5%;
    align-items: center;
    gap: 20px 2.66%;
}

.boxes-container li{
    width: 23%;
}

.box-container{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.main-image-container{
    width: 100%;
    border-radius: 4px;
    position: relative;
    background: url(https://cdn.shopify.com/s/files/1/1363/8433/files/cream_shape.png?v=1721312299) no-repeat;
    background-size: contain;
}

.main-image-container.selected{
    border: 1px solid #16A34A;
}

.green-check{
    position: absolute;
    top: 0;
    left: 0;
}
.main-image{
    width: 100%;
    box-sizing: border-box;
    cursor: pointer;
    position: relative;
    height: auto;
}

.main-image:hover{
    animation: MoveUpDown 2.5s ease-in-out infinite;
}

.box-title{
    font-size: 1.1vw;
    font-weight: bold;
    padding-top: 5%;
}

.box-desc{
    color: #A186C4 !important;
    font-size: 1vw;
    line-height: 1.4;
    padding-bottom: 5%;
}

.iframe-container{
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.2);
    z-index: 1;
}

.close-iframe{
    font-size: 2vw;
    cursor: pointer;
    position: absolute;
    top: 10%;
    right: 20%;
}

.content-header{
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding-top: 1%;
}

.content-header .title{
    font-size: 3.5vw;
    line-height: 1;
    font-family: Founders Grotesk, sans-serif;
    margin-bottom: 0.5rem;
}

.content-header .subtitle{
    font-size: 1.1vw;
    line-height: 1.2;
    text-align: center;
}

.box-warning{
    border: 1px solid #FF4545;
    background-color: #FFEBEB;
    font-size: 1vw;
    padding: 0.5rem 1rem;
    color: #0f0c38;
    text-align: center;
    max-width: 80%;
    border-radius: 4px;
    line-height: 1.2;
}

.box-warning img{
    width: 20px;
}

@media screen and (max-width: 767px){
    .main-title{
        font-size: 5vw;
    }
    .main-subtitle{
        font-size: 3vw;
        text-align: center;
    }

    .main-subtitle img {
        width: 4%;
        margin: 0% 1%;
    }

    .boxes-container{
        gap: 20px 4%;
        padding-bottom: 10%;
    }

    .boxes-container li{
        width: 48%;
    }

    .box-desc{
        font-size: 3vw;
    }

    .box-title{
        font-size: 3.5vw;
    }

    .iframe-container{
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background-color: rgba(0, 0, 0, 0.2);
        z-index: 1;
    }

    .close-iframe{
        font-size: 8vw;
        cursor: pointer;
        position: absolute;
        top: 0%;
        right: 5%;
    }

    .box-container .happybox-button{
        width: 100%;
        padding: 2%;
    }

    .content-header{
        padding-top: 5%;
    }

    .content-header .title{
        font-size: 6vw;
        margin-bottom: 0.5rem;
    }

    .content-header .subtitle{
        font-size: 3.5vw;
    }

    .box-warning{
        font-size: 3.5vw;
        max-width: 90%;
        margin-bottom: 40%;
    }
}
</style>